import useHomePage from "@/viewModels/home/useHomePage";
import BannerSlider from "@/components/ui/bannersSlider/BannerSlider";
import CategoryProducts from "@/pages/home/components/CategoryProducts";
import Features from "@/pages/home/components/Features";
import ShippingInfo from "@/pages/home/components/ShippingInfo";
import { banners, features } from "@/pages/home/homePageData";
import SEOMeta from "@/components/ui/meta/SEOMeta";

const HomePage = () => {
  const { productsByCategory, isLoadingProducts } = useHomePage();

  return (
    <main className="space-y-8">
      {/* Banner */}
      <section>
        <BannerSlider items={banners} isLoading={false} />
      </section>

      <div className="brand-container">
        {/* Category Products */}
        <section className="mt-16">
          <CategoryProducts
            productsByCategory={productsByCategory}
            isLoadingProducts={isLoadingProducts}
          />
        </section>

        {/* Features */}
        <section className="mt-10 lg:mt-12">
          <Features features={features} />
        </section>
      </div>

      {/* Shopping Info */}
      <section className="mt-10 bg-white pb-12 pt-2 lg:mt-12 lg:py-12">
        <div className="brand-container">
          <ShippingInfo />
        </div>
      </section>

      {/* Meta Tag */}
      <SEOMeta />
    </main>
  );
};

export default HomePage;
